<template>
  <div class="button-wrapper" data-type="default">
    <button
        class="button"
        type="submit"
        v-bind="{...$attrs}"
    >
      <v-progress-circular
          v-if="loading"
          indeterminate
          :size="18"
          :width="1"
          color="primary"
          class="ondigo-btn-loading"
      />
      <span
          v-else
          :class="this.icon"
      />
      {{ btnLabel }}
    </button>
  </div>
</template>

<script>
export default {
  name: "ThueSubmitButton",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    btnLabel: {
      type: String,
      default: 'Submit'
    },
    alignment: {
      type: String,
      default: 'left'
    },
    formName: {
      type: String,
      default: null
    }
  },
  computed: {
    icon() {
      if (this.formName && this.formName.startsWith('newsletter')) {
        return 'on-icon-mail';
      }

      return 'on-icon-right';
    }
  }
}
</script>
